<div [bpTooltip]="(user$ | async)?.displayName || email || ''">
	<ng-container *ngIf="user$ | async as user">
		<img *ngIf="!showPlaceholder" [src]="user!.avatarUrl" (error)="showPlaceholder = true" />
	</ng-container>

	<span class="placeholder">
		<mat-icon>person</mat-icon>
	</span>
</div>
